import { render, staticRenderFns } from "./DocEditor.vue?vue&type=template&id=7a0ea1e5&scoped=true"
import script from "./DocEditor.vue?vue&type=script&lang=js"
export * from "./DocEditor.vue?vue&type=script&lang=js"
import style0 from "./DocEditor.vue?vue&type=style&index=0&id=7a0ea1e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0ea1e5",
  null
  
)

export default component.exports